var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-icon-wrap",class:_vm.logoClass},[(_vm.src)?_c('div',{staticClass:"logo-icon",style:(_vm.logoStyle)}):_c('SVGIcon',_vm._b({attrs:{"icon-name":"profile-sidebar/profile"}},'SVGIcon',_vm.iconSize,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }